import { render, staticRenderFns } from "./message-content-vcard.vue?vue&type=template&id=c69494f6&scoped=true&"
import script from "./message-content-vcard.vue?vue&type=script&lang=js&"
export * from "./message-content-vcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69494f6",
  null
  
)

export default component.exports